import { useNavigate } from 'react-router-dom';
import ManorShell from './ManorShell';

// Rules screen (begin.php).
export default function ManorBegin() {
  const navigate = useNavigate();
  return (
    <ManorShell bg="begin/bg.png" bgMob="img/begin/bg_mob.jpg">
      <img className="manor-drop manor-title" style={{ top: '5%' }} src="/manor/img/begin/text.png" alt="Rules" />
      <button type="button" className="manor-img-btn manor-begin-btn" onClick={() => navigate('/manor/home')}>
        <img src="/manor/img/begin/button.png" alt="Continue" />
      </button>
    </ManorShell>
  );
}
